module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-1-3b45abc27b77dbb5b6c7cd56c59f3671.jpg";